export default "__VITE_PUBLIC_ASSET__bb4a4707__"